import { DRAWER_MODE } from 'components/SideDrawer/SideDrawer';

export const DRAWER_WIDTH = {
    [DRAWER_MODE.SMALL]: 672,
    [DRAWER_MODE.MEDIUM]: 1000,
    [DRAWER_MODE.MEDIUM_LARGE]: 1436,
    [DRAWER_MODE.LARGE]: '100vw',
};

const PROPORTIONED_POSITION = false;

const LAYERS_BASIC_GAP_PX = 64;

export const getLayerWidthPx = (drawerMode, screenWidth) => {
    return drawerMode === DRAWER_MODE.LARGE ? screenWidth : DRAWER_WIDTH[drawerMode];
};

export const getRestrictedLayerWidthPx = (width, index, screenWidth) =>
    Math.min(width, screenWidth - index * LAYERS_BASIC_GAP_PX);

export const calcLayerShift = ({ aboveLayerWidth, topLayerWidth, drawerSize, width, index, screenWidth }) => {
    const proportionalGapPx = (screenWidth - topLayerWidth) / (drawerSize - 1);
    const proportionalShift = index * proportionalGapPx;
    const currentShift = screenWidth - width;

    const resolvedShift = PROPORTIONED_POSITION
        ? Math.max(proportionalShift, screenWidth - (aboveLayerWidth + width))
        : screenWidth - (aboveLayerWidth + LAYERS_BASIC_GAP_PX);

    const leftShift = Math.min(currentShift, resolvedShift);
    const rightShift = screenWidth - leftShift - width;

    return rightShift;
};
